import { gql } from "@apollo/client";

export const HELP_REQUEST_FIELDS_FRAGMENT = gql`
  fragment HelpRequestFields on HelpRequestRepresentation {
    id
    helpRequestRef
    entityType
    entityId
    subject
    content
    requesterId
    status
    attachments
    createdAt
  }
`;

export const INCIDENT_FIELDS_FRAGMENT = gql`
  fragment IncidentFields on IncidentRepresentation {
    id
    incidentRef
    priority
    assigneeId
    requestId
    createdBy
    modifiedBy
    createdAt
    updatedAt
  }
`;

export const HELP_REQUEST_MESSAGE_FIELDS_FRAGMENT = gql`
  fragment HelpRequestMessageFields on HelpRequestMessage {
    id
    requestId
    senderId
    senderRole
    content
    createdAt
  }
`;

export const INCIDENT_COMMENT_FIELDS_FRAGMENT = gql`
  fragment IncidentCommentFields on IncidentComment {
    id
    incidentId
    senderId
    content
    attachments
    createdAt
  }
`;

export const AUDIT_EVENT_FIELDS_FRAGMENT = gql`
  fragment AuditEventFields on AuditEvent {
    id
    requestId
    incidentId
    actorId
    eventType
    previousValue
    newValue
    createdAt
  }
`;
